import type { ButtonHTMLAttributes, ReactNode } from 'react';

import Button, { type ButtonSize, type ButtonVariant } from '@/components/Button/Button';
import { cn } from '@/lib/cn';

interface IconButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  icon: ReactNode;
  'aria-label': string;
  variant?: ButtonVariant;
  size?: ButtonSize;
}

const sizeShape: Record<ButtonSize, string> = {
  sm: 'h-8 w-8 p-0',
  md: 'h-10 w-10 p-0',
  lg: 'h-12 w-12 p-0',
};

export default function IconButton({ icon, size = 'md', className, ...rest }: IconButtonProps) {
  return (
    <Button size={size} className={cn(sizeShape[size], className)} {...rest}>
      <span className="flex h-5 w-5 items-center justify-center">{icon}</span>
    </Button>
  );
}
